import React, { useState, useEffect, ChangeEvent } from 'react';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';

interface DateTimeInputProps {
  initialValue: string;
  onDateTimeChange: (value: string) => void;
}

const DateTimeInput: React.FC<DateTimeInputProps> = ({ initialValue, onDateTimeChange }) => {
  const [selectedDateTime, setSelectedDateTime] = useState(initialValue);

  useEffect(() => {
    if (isValidDateTime(initialValue)) {
      setSelectedDateTime(initialValue);
    }
  }, [initialValue]);

  const handleDateTimeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    console.debug(value);
    setSelectedDateTime(value);
  };

  const isValidDateTime = (value: string) => {
    const minDateTime = new Date('1900-01-01T00:00').getTime();
    const maxDateTime = new Date('2999-01-01T00:00').getTime();
    const selectedDateTime = new Date(value).getTime();
    return selectedDateTime >= minDateTime && selectedDateTime <= maxDateTime;
  };

  return (
    <Box component="span" display="inline-flex" alignItems="center">
      <TextField
        type="datetime-local"
        id="dateTimeInput"
        value={selectedDateTime}
        onChange={handleDateTimeChange}
        onBlur={(event) => {
          const value = event.target.value;
          if (isValidDateTime(value)) {
            onDateTimeChange(value);
          } else {
            //console.debug(['reset', selectedDateTimeDef]);
            setSelectedDateTime(initialValue);
          }
        }}
      />
    </Box>
  );
};

export default DateTimeInput;
